<template>
  <div ref="mainContent" class="main-content">
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
  padding: 20px;
  box-sizing: border-box;
  margin-left: 20px;
}
</style>
